"use client"

import { BaseModal } from "@/components/BaseModal"
import { EducationItem } from "@/data/education"
import { useLocale } from "next-intl"

type EducationModalProps = {
  item: EducationItem
  itemIndex: number
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Education Modal Component
 * 
 * Uses the standardized BaseModal with education-specific settings
 */
export default function EducationModal({ item, /* itemIndex, */ open, onOpenChange }: EducationModalProps) {
  const locale = useLocale()
  
  return (
    <BaseModal
      item={{
        title: item.name,
        image: item.image,
        imageDark: item.imageDark,
        website: item.website,
        subtitle: item.program,
        description: item.description,
        date: item.period,
        tags: item.tags,
        displayTags: item.displayTags,
        references: item.references
      }}
      open={open}
      onOpenChange={onOpenChange}
      locale={locale}
    />
  )
}